
import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import * as XLSX from 'xlsx';
import UtilsLocalizedExcelString from '../services/utilsLocalizedExcelString.jsx';
import '../styles/pages.css'; 


function GlossaryPage(props) {
      const { t } = useTranslation();
      const [excelLoadedSheet, setExcelLoadedSheet] = useState(false);
      const [excelDataSheet, setExcelDataSheet]= useState("");
    
      useEffect(() => {
    
    
    const handleFetchFromUrl = async () => {
    if(!excelLoadedSheet) {
    try {
      const url = "https://storage.googleapis.com/fgr-data-visualisation-assets/fgr_silvagris_assets.xlsx";
      const response = await axios.get(url, { responseType: 'arraybuffer' });
      const data = new Uint8Array(response.data);
      const workbook = XLSX.read(data, { type: 'array' });
      const sheetName = workbook.SheetNames[4];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      setExcelDataSheet(jsonData);
      setExcelLoadedSheet(true);
    } catch (error) {
    
      console.error('Error fetching or parsing Excel file:', error);
    }
  }
  };
  
  
    handleFetchFromUrl();

  }, [props.lang, excelLoadedSheet]);
    return (
      <React.Fragment>
        <div className="App">
         <br></br> 
     <h5 className="title-body">{t('glossary_title')}</h5>
<br/>
<div className="wrapper">
   
     <Table  borderless 
      style ={{ borderSpacing: "0",borderCollapse: "collapse",
      borderStyle: "hidden", marginBottom: "0px",  
      borderBottom:"0px solid trasparent !important", 
      orderBottomWidth: "0"}} >
        
   {excelDataSheet !== "" &&
   <tbody>
        {(() => {
        let rows = [];
        for (let i = 1; i < excelDataSheet.length; i+=2) {
          rows.push(<tr key={excelDataSheet[i]} style={{ borderTop: "0.5px solid rgb(187, 186, 186)"}}>
          <td style={{backgroundColor:"#F2F2F2" }}><p style={{marginTop: "1rem"}}>
            <span className="table-grey-column-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[i])}</span>
          </p></td>

            <td className="col-9"><p style={{marginTop: "1rem", }}>
            <span className="table-grey-column-non-bold-text">{UtilsLocalizedExcelString(props.lang, excelDataSheet[i+1])}
             </span></p>
            </td>
        </tr>);
        }
        return rows;
      })()}      
      </tbody>}
    </Table>
    
    </div>
    </div>
      </React.Fragment>
    );
  }

  export default GlossaryPage;